import { Component, EventEmitter, Output } from '@angular/core';
import { CompaniesContractDialogComponent } from 'src/app/companies/companies-contract-dialog/companies-contract-dialog.component';
import { Company, CompaniesService, CompanyStatus } from 'src/app/core/companies.service';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { ERROR_COMPANY_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-home-acceptance-companies',
  templateUrl: './home-acceptance-companies.component.html',
  styleUrls: ['./home-acceptance-companies.component.scss'],
})
export class HomeAcceptanceCompaniesComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = false;
  companies?: Company[];

  constructor(
    private companies_service: CompaniesService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
    private dialog_service: DialogService,
    private utils_service: UtilsService,
  ) {}

  ngOnInit(): void {
    this.listCompanies();
  }

  onRefresh(): void {
    this.listCompanies();
  }

  onSeeAllClick(): void {
    this.navigation_service.toCompanies();
  }

  onContractClick(company: Company): void {
    this.dialog_service
      .openDialog(CompaniesContractDialogComponent, { company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }

  listCompanies(): void {
    this.is_list_running = true;
    const status = CompanyStatus.pending_acceptance;
    this.companies_service.listCompanies({ status }).subscribe({
      next: response => {
        this.companies = response.data.data;
        this.companies = this.companies?.slice(0, 5);
        this.is_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_COMPANY_NOT_FOUND) {
          this.companies = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
      },
    });
  }

  getCompanyStatusBackgroundClass(company: Company): { [key: string]: boolean } {
    return this.utils_service.getCompanyStatusBackgroundClass(company);
  }
}
